import { Component, Input, OnInit } from '@angular/core';
import { UserGroup } from "../../../app/app.interfaces";

@Component({
  selector: 'user-group-sidebar',
  templateUrl: 'user-group-sidebar.html'
})
export class UserGroupSidebar{
  @Input() userGroup: UserGroup;
  
}


// WEBPACK FOOTER //
// ./src/partials/user-group/user-group-sidebar/user-group-sidebar.ts